import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0835792e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "callRoom" }

import { useGetCallRoomProperties } from "@/composables/useGetCallRoomProperties";
import CallRoomBackground from "../CallRoomBackground/CallRoomBackground.vue";
import CallDominantSpeaker from "../CallDominantSpeaker/CallDominantSpeaker.vue";
import CallParticipantsPanel from "../CallParticipantsPanel/CallParticipantsPanel.vue";
import InitialCallScreen from "../InitialCallScreen/InitialCallScreen.vue";
import CallControlPanel from "../CallControlPanel/CallControlPanel.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CallRoom',
  setup(__props) {

const { data } = useGetCallRoomProperties();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(CallRoomBackground),
    (!_unref(data).participants.length && !_unref(data).dominantParticipant?.participant)
      ? (_openBlock(), _createBlock(InitialCallScreen, { key: 0 }))
      : (!!_unref(data).dominantParticipant)
        ? (_openBlock(), _createBlock(CallDominantSpeaker, {
            key: _unref(data).dominantParticipant.participant?.identity,
            "room-participant": _unref(data).dominantParticipant
          }, null, 8, ["room-participant"]))
        : _createCommentVNode("", true),
    _createVNode(CallParticipantsPanel, {
      "local-participant": _unref(data).localParticipant,
      participants: _unref(data).participants
    }, null, 8, ["local-participant", "participants"]),
    _createVNode(CallControlPanel, {
      room: _unref(data).room,
      "display-name": _unref(data).dominantParticipant?.user?.name ?? ''
    }, null, 8, ["room", "display-name"])
  ]))
}
}

})